(function () {
  'use strict';

  var ELEVATION_IMAGE = 'https://cdn.shopify.com/s/files/1/0646/3268/4615/files/WC_2021-11-11_mono_8_of_245.jpg?v=1782478012';

  function replaceVisibleText(root, pattern, replacement) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      if (!node.parentElement || /^(SCRIPT|STYLE|NOSCRIPT)$/.test(node.parentElement.tagName)) continue;
      if (pattern.test(node.nodeValue || '')) {
        node.nodeValue = node.nodeValue.replace(pattern, replacement);
      }
      pattern.lastIndex = 0;
    }
  }

  function fixVineyardElevationImage(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('img[alt="Veraison - grapes changing colour"], img[data-wc-elevation-image]').forEach(function (image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = ELEVATION_IMAGE;
      image.alt = 'Two people walking through the Weathercraft vineyard';
      image.dataset.wcElevationImage = 'true';
    });
  }

  function run(root) {
    var scope = root || document;
    fixVineyardElevationImage(scope);
    replaceVisibleText(
      scope === document ? document.getElementById('MainContent') : scope,
      /gravelly inclines and spare/gi,
      'gravelly incline and sparse'
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); }, { once: true });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target || document);
  });
})();
